<template>
  <!-- ヘッダーコンテンツ: ツールチップ -->
  <div class="l-header-tooltip">
    <a class="c-btn c-btn--square c-btn--tooltip u-wh64" href="#tooltip">
      <div class="c-icon u-wh28 c-icon--white c-icon--alpha70">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <use xlink:href="/assets/img/sprite.svg#question" />
        </svg>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  emits: ["open"],
  data: function () {
    return {
      notifications: null,
    }
  },
  mounted: function () {
    this.notifications = $('.l-header-info__list');
  },
  methods: {
    isOpen: function(){
      return this.notifications.hasClass('is-active');
    },
    imageClick: function(){
      if (!this.isOpen()) {
        this.open();
      } else {
        this.close();
      }
    },
    closeClick: function(){
      this.close();
    },
    open: function(){
      this.notifications.addClass('is-active');
      this.$emit('open');
    },
    close: function(){
      this.notifications.removeClass('is-active');
    },
  }
};
</script>